import { Component, OnInit } from "@angular/core";
import { JobStatusService } from "../../jobStatus/jobStatus.service";

@Component({
  selector: "enrollment-windows-table",
  templateUrl: "./enrollment-windows-table.component.html",
  styleUrls: ["./enrollment-windows-table.component.scss"],
})
export class EnrollmentWindowsTableComponent implements OnInit {
  enrollmentWindowYears;
  enrollmentWindows;
  constructor(private jobStatusService: JobStatusService) {}

  ngOnInit() {
    this.jobStatusService.updatedCustomerConfigChange.subscribe((value) => {
      this.enrollmentWindowYears = this.jobStatusService.getEnrollmentWindowYears();
    });
  }

  dateChanged(dateStr, enrollmentYear, dateType) {
    this.jobStatusService.enrollmentWindowInputErrors[
      "enrollment." + enrollmentYear + "." + dateType
    ] = dateStr == "mm/dd/yyyy" || dateStr == "";
  }

  showError(enrollmentYear, dateType) {
    return (
      this.jobStatusService.enrollmentWindowInputErrors &&
      this.jobStatusService.enrollmentWindowInputErrors[
        "enrollment." + enrollmentYear + "." + dateType
      ]
    );
  }
}
